import { Stack } from "@mui/material";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import WbSunnyOutlinedIcon from "@mui/icons-material/WbSunnyOutlined";
import WbSunnyTwoToneIcon from "@mui/icons-material/WbSunnyTwoTone";

const Sunlight = ({ value }) => {
  const icons = {
    "full sun": <WbSunnyIcon />,
    "partial shade": <WbSunnyTwoToneIcon />,
    shade: <WbSunnyOutlinedIcon />,
  };

  return (
    <Stack direction="row" spacing={1}>
      {value.map((sunlight) => (
        <Stack key={sunlight} direction="row" alignItems="center" spacing={1}>
          {icons[sunlight.toLowerCase()]}
        </Stack>
      ))}
    </Stack>
  );
};

export default Sunlight;
